<template>
    <el-dialog custom-class="cf-dialog" :visible.sync="visible" :title="$t('lang.单位管理')" width="600px" append-to-body @close="close" :close-on-click-modal="false">
        <div class="action-btn">
            <el-button size="mini" @click="$refs.add.open()" type="primary">{{ $t('lang.新增') }}</el-button>
        </div>
        <el-table :data="data" border height="600px">
            <el-table-column prop="name" :label="$t('lang.单位名称')"></el-table-column>
            <el-table-column prop="name" :label="$t('lang.操作')" width="100">
                <template slot-scope="scope">
                    <el-link size="mini" :underline="false" class="action-el-link" @click="$refs.edit.open(scope.row.code)" plain type="primary" >{{$t('lang.编辑')}}</el-link>
                    <el-link size="mini" :underline="false" class="action-el-link" @click="handleDelete(scope.row)" plain type="danger" >{{$t('lang.删除')}}</el-link>
                </template>
            </el-table-column>
        </el-table>

        <unit-add ref="add" @finish="handleLoadData"></unit-add>
        <unit-edit ref="edit" @finish="handleLoadData"></unit-edit>

    </el-dialog>
</template>

<script>
    import UnitAdd from "./UnitAdd";
    import UnitEdit from "./UnitEdit";
    export default {
        name: "UnitList",
        components: {UnitEdit, UnitAdd},
        data() {
            return {
                data: [],
                visible:false
            }
        },
        methods: {
            open() {
                this.visible = true;
            },
            close() {
                this.visible = false;
            },
            async handleLoadData() {

                let resp = await this.$http.post(this.$api.boUnit.list, this.$qs.stringify({onPage: false}));
                if (resp.data.status === 200) {
                    this.data = resp.data.data.boUnits;
                } else {
                    this.$message.error(this.$t('lang.加载数据出错'));
                }

            },
            async handleDelete(row){
                this.$confirm(this.$t('lang.你正在进行菜谱单位删除操作'), this.$t('lang.提示'), {
                    confirmButtonText: this.$t('lang.确定'),
                    cancelButtonText: this.$t('lang.取消'),
                    type: 'warning'
                }).then(async () => {
                    let resp = await this.$http.post(this.$api.boUnit.delete,this.$qs.stringify({code:row.code}));
                    if(resp.data.status === 200){
                        this.$message.success(this.$t('lang.操作成功'));
                        this.handleLoadData();
                        this.$store.dispatch("UPDATE_UNIT");
                    }else{
                        this.$message.error(resp.data.desc);
                    }
                }).catch(() => {

                });

            }
        },
        created() {
            this.handleLoadData();
        }
    }
</script>

<style scoped>
.action-btn{
    margin-bottom: 12px;
}
</style>
